import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let blocks = document.querySelectorAll('.team');

if (blocks.length > 0) {
    blocks.forEach(block => {
        const wrapper = block.querySelector('.team-wrapper');
        const persons = block.querySelectorAll('.team-person');
        const personChildren = block.querySelectorAll('.team-person > *');

        // Set initial states
        gsap.set(persons, { autoAlpha: 0, y: -50 });
        gsap.set(personChildren, { autoAlpha: 0, y: -15 });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapper,
                start: 'top 90%',
            }
        });

        tl.to(persons, {
            autoAlpha: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.1,
            ease: 'power2.out'
        });

        tl.to(personChildren, {
            autoAlpha: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.05,
            ease: 'power2.out'
        }, '-=0.3');
    });
}